import { useTranslation } from 'react-i18next';

const ContractTerminationReason = ({ terminationReason }) => {
    const { t } = useTranslation();

    return terminationReason ? t(`contract.terminationReason.${terminationReason}`) : '';
};

export default ContractTerminationReason;
